import React from 'react';
import "./FactorPrintStyles.css"
import Barcode from "react-barcode";

const BillPrint = (props) => {
  return (
<>
  {/*<style>{factorPrintStyles}</style>*/}
  <main className="container__billPrintFromTable" dir="rtl">
    <header className="factor-header">
      <div className="bill__logo">
      </div>
      <div className="title">
        <b> صورتحساب فاکتور</b>
      </div>
      <div className={""}>
        <div className="box fd-font small_font_bill" id="Memo72"><span></span>:<span></span></div>
        <div>
          {props.barcodeData && <Barcode
            value={props.barcodeData}
            height={30}
            // height={12}
            format={"CODE128B"}
            width={1.3}
            // width={12}
            fontSize={10}
            margin={0}
            displayValue={false}
          />}
        </div>
        <div className="box fd-font small_font_bill" id="Memo69"><span></span>:<span></span></div>
      </div>
    </header>

    <table className="header_useless">
      <tr>
        <td colSpan="3" className="center">فروشنده</td>
        <td colSpan="3" className="center">خریدار</td>
      </tr>
      <tr>
        <td colSpan="3">
          <div className="content">
            <div className="float">
              <div className="box" id="Memo10"><b>-</b> : <span></span></div>
            </div>
            <div className="float">
              <div className="box" id="Memo21"><b>-</b> : <span></span></div>
              <div className="box" id="Memo22"><b>-</b> : <span></span></div>
            </div>
            <div className="float">
              <div className="box" id="Memo12"><b>-</b> : <span></span></div>
              <div className="box" id="Memo11"><b>-</b> : <span></span></div>
            </div>
          </div>
        </td>
        <td colSpan="3">
          <div className="content">
            <div className="float">
              <div className="box" id="customerName"><b> نام خریدار</b> : <span>  </span></div>
            </div>
            <div className="float">
              <div className="box" id="customerMobile"><b>شماره موبایل</b> : <span>  </span></div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <table className="body">
      <thead>
      <tr id="columns"></tr>
      </thead>
      <tbody id="data">
      </tbody>
      <tfoot>
      <tr id="Memo68" className="d-none">
        <td colSpan="4" className="left"></td>
        <td colSpan="2"></td>
      </tr>
      <tr id="Memo65" className="d-none">
        <td colSpan="4" className="left"></td>
        <td colSpan="2"></td>
      </tr>
      <tr id="Memo64" className="d-none">
        <td colSpan="4" className="left"></td>
        <td colSpan="2"></td>
      </tr>
      <tr id="Memo67" className="left d-none">
        <td colSpan="2"></td>
        <td colSpan="4"></td>
      </tr>

      </tfoot>
    </table>
    <div className="d-flex justify-content-center align-items-center  text-center">
      <div className="box" id="Memo18"><span className={"d-none"}></span> <span></span></div>
    </div>
  </main>
</>
  );
};

export default BillPrint;
